import { LOYALTY_PROGRAM_FILTER_VALUES } from 'store/filters/loyalty-filter-utils';
export default function getFilters(filters) {
    if (!filters) {
        return [];
    }
    const { activeReservationType, activeAmenities, loyaltyProgram } = filters;
    const allFilters = [
        ...activeAmenities,
        ...(activeReservationType !== 'all' ? [activeReservationType] : []),
        ...(loyaltyProgram === LOYALTY_PROGRAM_FILTER_VALUES.ON
            ? ['colonial-flex']
            : []),
    ];
    return allFilters.map(filter => {
        return { value: filter };
    });
}
